module.exports = __webpack_public_path__ + "img/twitter-logo.2d1fb85e.png";